/**
 * Configuracao dos filtros para a listagem de Modelos Veiculares
 */
export const filterConfig = [
  {
    id: 'search',
    type: 'text',
    label: 'Busca (descricao ou codigo)',
    placeholder: 'Digite a descricao ou codigo',
  },
  {
    id: 'situacao',
    type: 'select',
    label: 'Situacao',
    options: [
      { label: 'Todos', value: '' },
      { label: 'Ativo', value: 'ATIVO' },
      { label: 'Inativo', value: 'INATIVO' },
    ],
  },
  {
    id: 'codigoTipoModeloVeicular',
    type: 'text',
    label: 'Codigo do Tipo de Modelo Veicular',
    placeholder: 'Ex: SR, TRK, VAN...',
  },
  {
    id: 'unidadeCapacidade',
    type: 'select',
    label: 'Unidade de Capacidade',
    options: [
      { label: 'Todos', value: '' },
      { label: 'kg', value: 'KG' },
      { label: 'ton', value: 'TON' },
      { label: 'm3', value: 'M3' },
      { label: 'pallet', value: 'PALLET' },
      { label: 'unidade', value: 'UN' },
    ],
  },
  {
    id: 'codigoTipoCargaANTT',
    type: 'text',
    label: 'Codigo Tipo de Carga ANTT',
    placeholder: 'Digite o codigo ANTT',
  },
  {
    id: 'codigoIntegracao',
    type: 'text',
    label: 'Codigo de Integracao',
    placeholder: 'Digite o codigo de integracao',
  },
  {
    id: 'nomeTipoModeloVeicular',
    type: 'text',
    label: 'Nome do Tipo de Modelo Veicular',
    placeholder: 'Digite o nome do tipo de modelo',
  },
  {
    id: 'ocupacaoCubicaPallets',
    type: 'number',
    label: 'Ocupacao Cubica (pallets)',
  },
  {
    id: 'ocupacaoCubicaMaxima',
    type: 'number',
    label: 'Ocupacao Cubica Maxima',
  },
  {
    id: 'quantidadePallet',
    type: 'number',
    label: 'Quantidade de Pallet',
  },
  {
    id: 'capacidadeMaximoPallets',
    type: 'number',
    label: 'Capacidade Maxima Pallets',
  },
  {
    id: 'toleranciaMinimaPallets',
    type: 'number',
    label: 'Tolerancia Minima (pallets)',
  },
  {
    id: 'toleranciaMinimaCarregamento',
    type: 'number',
    label: 'Tolerancia Minima de Carregamento',
  },
  {
    id: 'numeroEixos',
    type: 'number',
    label: 'Numero de Eixos',
  },
  {
    id: 'capacidadeModelo',
    type: 'number',
    label: 'Capacidade do Modelo',
  },
  {
    id: 'quantidadeExtraExcedenteTolerado',
    type: 'number',
    label: 'Quantidade Extra Excedente Tolerada',
  },
  {
    id: 'toleranciaExtra',
    type: 'number',
    label: 'Tolerancia Extra',
  },
];

